import { Outlet } from "react-router";

import Footer from "../../components/ui/footer";
import Header from "../../components/ui/header";
// import { useEffect } from "react";
// import { useLingui } from "@lingui/react";

export const HomeLayout = () => {
  // const { i18n } = useLingui();

  // useEffect(() => {
  //   const rtlLocales = ["fa-IR", "ar-SA", "he-IL", ];
  //   if (rtlLocales.includes(i18n.locale)) {
  //     document.body.dir = "rtl";
  //   } else {
  //     document.body.dir = "ltr";
  //   }
  // }, []);

  return (
    <div className="light">
      <Header />
      <main className="grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
